import { render, staticRenderFns } from "./ProjetoAnexoDownload.vue?vue&type=template&id=29e3cb06"
import script from "./ProjetoAnexoDownload.vue?vue&type=script&lang=js"
export * from "./ProjetoAnexoDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports